import { BaseCachePayload } from 'src/app/cache/base-cache.payload';

export class TagCachePayload extends BaseCachePayload {

}
